import { BellFilled, LogoutOutlined } from "@ant-design/icons";
import { Badge, Drawer, List, Space,  } from "antd";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuthenticator } from '@aws-amplify/ui-react';
import { useRecoilState } from "recoil"
import { allSitesAtom } from "../../Atoms/allSitesAtom"
// import { getAlerts } from "../../API";

function AppHeader() {
  const navigate = useNavigate();
  const [allSites, setAllSites] = useRecoilState(allSitesAtom)
  const [alerts, setAlerts] = useState([]);
  const [alertsOpen, setAlertsOpen] = useState(false);
  const { user, signOut } = useAuthenticator((context) => [context.user]);

  useEffect(() => {
    if(user) {
      // getAlerts().then((res) => {
      //   setAlerts(res.comments);
      // }).catch((err) => {console.log("Error: ", err)});
    }
  }, [user]);

  return (
    <div className="AppHeader">
      <img
        width={225}
        src="/logo.png"
        onClick={() => navigate("/") }
        // alt="SwimSense Logo"
      ></img>
      {user && (
      <>
      <Space>
        <Badge count={alerts.length} dot>
          <BellFilled
            style={{ fontSize: 24 }}
            onClick={() => {
              setAlertsOpen(true);
            }}
          />
        </Badge>
        <LogoutOutlined
          style={{ fontSize: 24, marginLeft: 20 }}
          onClick={() => {
            navigate("/")
            setAllSites({})
            signOut();
          }}
        />
      </Space>
      <Drawer
        title="Alerts"
        open={alertsOpen}
        onClose={() => {
          setAlertsOpen(false);
        }}
        maskClosable
      >
        <List
          dataSource={alerts}
          renderItem={(item) => {
            return <List.Item>{item.body}</List.Item>;
          }}
        ></List>
      </Drawer>
      </>
      )}
    </div>
  );
}
export default AppHeader;
